export default {
  APP_NAME: 'iHeart',
  APP_NAME_TWITTER: '@iHeartRadio',
  APPLE_ID: 290638154,
  GOOGLE_PLAY_ID: 'com.clearchannel.iheartradio.controller',
  WEB_SITE: 'iheart.com',
};
